import { SvgIcon, SvgIconBaseProps } from '@honeycomb/ui-core';
import * as React from 'react';

export function InstagramIcon(props: SvgIconBaseProps): React.JSX.Element {
    return (
        <SvgIcon {...props} viewBox="0 0 40 40">
            <defs>
                <path id="a" d="M0 40h40V0H0z" />
            </defs>
            <g fill="none" fillRule="evenodd">
                <path
                    d="M5.714 0h28.572A5.715 5.715 0 0 1 40 5.714v28.572A5.715 5.715 0 0 1 34.286 40H5.714A5.715 5.715 0 0 1 0 34.286V5.714A5.715 5.715 0 0 1 5.714 0z"
                    fill="#AF3794"
                />
                <path
                    d="M11.853 7.567h16.293a4.286 4.286 0 0 1 4.285 4.286v16.293a4.285 4.285 0 0 1-4.285 4.285H11.853a4.285 4.285 0 0 1-4.286-4.285V11.853a4.286 4.286 0 0 1 4.286-4.286"
                    fill="#FFF"
                />
                <path d="M20.389 24.692a4.324 4.324 0 1 0 0-8.648 4.324 4.324 0 0 0 0 8.648" fill="#AF3794" />
                <path
                    fill="#AF3794"
                    mask="url(#b)"
                    d="M25.629 15.133h4.142V10.99H25.63zM27.027 20.396A6.68 6.68 0 0 1 20.37 27.1a6.68 6.68 0 0 1-6.207-9.212H10.52v10a2.335 2.335 0 0 0 2.333 2.335H27.84a2.333 2.333 0 0 0 2.336-2.333V17.888h-3.643c.325.797.494 1.647.497 2.508h-.003z"
                />
            </g>
        </SvgIcon>
    );
}
